export default {
  " ({serviceCharge}%)": " ({serviceCharge}%)",
  " ({taxRate}%)": " ({taxRate}%)",
  " ({variant})": " ({variant})",
  " - we'll also email {customer_email}": " - وسنرسل أيضًا بريدًا إلى {customer_email}",
  " and table service": " وخدمة الطاولات",
  " · {description}": " · {description}",
  "% off": "% خصم",
  "(Inactive)": "(غير نشط)",
  "(optional - get order updates)": "(اختياري - لتلقي تحديثات الطلب)",
  "(recommended - get your receipt and updates)": "(موصى به - لتلقي الإيصال والتحديثات)",
  ") - Stock:": ") - المخزون:",
  ") and that it arrived in your bank account before approving.": ") ومن وصوله إلى حسابك البنكي قبل الموافقة.",
  "*** KITCHEN COPY ***": "*** نسخة المطبخ ***",
  "*** Kitchen Copy ***": "*** نسخة المطبخ ***",
  "+ Add": "+ إضافة",
  "+ Add image (optional)": "+ إضافة صورة (اختياري)",
  "+ Add loyalty customer": "+ إضافة عميل ولاء",
  "+/- points": "+/- نقاط",
  ". Pick your party size, a green day, and a time. We will take care of the table.": ". اختر عدد الأشخاص ويومًا باللون الأخضر ووقتًا، وسنتكفل بالطاولة.",
  ". Use test keys (pk_test_ / sk_test_) to try it first.": ". استخدم مفاتيح الاختبار (pk_test_ / sk_test_) للتجربة أولًا.",
  ". You'll be contacted at": ". سنتواصل معك على",
  "/ Min:": "/ الحد الأدنى:",
  "/mo": "/شهريًا",
  "01 / Your details": "01 / بياناتك",
  "02 / How would you like it?": "02 / كيف تريد استلامه؟",
  "03 / Payment": "03 / الدفع",
  "2-3 column grid • High contrast • Quick ordering": "شبكة من عمودين أو ثلاثة • تباين عالٍ • طلب سريع",
  "2-column list • Large images • Bold headers": "قائمة بعمودين • صور كبيرة • عناوين عريضة",
  "3-column grid • Gradient hero • Card layout": "شبكة بثلاثة أعمدة • واجهة متدرجة • تصميم بطاقات",
  "4-column grid • Minimal borders • Light typography": "شبكة بأربعة أعمدة • حدود خفيفة • خطوط رقيقة",
  "A LITTLE DISCOVERY, EVERY DAY.": "اكتشاف صغير كل يوم.",
  "A beautiful shop with a cart, checkout and stock that updates itself.": "متجر جميل مع سلة ودفع ومخزون يتحدث تلقائيًا.",
  "A cream paper carte in two columns with dotted price leaders, no photos": "قائمة ورقية بلون الكريم في عمودين مع خطوط منقطة للأسعار، بدون صور",
  "A little time.": "قليل من الوقت.",
  "A seat at our table.": "مقعد على طاولتنا.",
  "A small, edited collection. Nothing extra.": "تشكيلة صغيرة مختارة بعناية. لا شيء زائد.",
  "A table for you.": "طاولة من أجلك.",
  "ADD": "إضافة",
  "Accent": "اللون المميز",
  "Accent Color": "اللون المميز",
  "Accept cards with your own Stripe account, bank transfers with receipt upload, or cash.": "اقبل البطاقات عبر حساب Stripe الخاص بك، أو التحويلات البنكية مع رفع الإيصال، أو الدفع نقدًا.",
  "Accept table reservations online": "قبول حجوزات الطاولات عبر الإنترنت",
  "Accept {title}": "قبول {title}",
  "Access denied": "تم رفض الوصول",
  "Access has been paused by the platform owner. Your storefront is offline, and new orders can't be taken until this is resolved. Contact the platform owner to reactivate.": "أوقف مالك المنصة الوصول مؤقتًا. متجرك غير متاح حاليًا ولا يمكن استقبال طلبات جديدة حتى يتم حل المشكلة. تواصل مع مالك المنصة لإعادة التفعيل.",
  "Accessibility needs, a special occasion…": "احتياجات خاصة، مناسبة مميزة…",
  "Account": "الحساب",
  "Account Status": "حالة الحساب",
  "Across all locations": "في جميع الفروع",
  "Actions": "الإجراءات",
  "Activate": "تفعيل",
  "Activate theme": "تفعيل الثيم",
  "Active": "نشط",
  "Active (available for customers)": "نشط (متاح للعملاء)",
  "Active (visible to customers)": "نشط (ظاهر للعملاء)",
  "Active items": "العناصر النشطة",
  "Active reservations": "الحجوزات النشطة",
  "Active services": "الخدمات النشطة",
  "Activity Logs": "سجل النشاط",
  "Add": "إضافة",
  "Add Another Ingredient": "إضافة مكوّن آخر",
  "Add Category": "إضافة تصنيف",
  "Add Column": "إضافة عمود",
  "Add Employee": "إضافة موظف",
  "Add First Stock Item": "إضافة أول عنصر مخزون",
  "Add First Table": "إضافة أول طاولة",
  "Add Item": "إضافة عنصر",
  "Add New Category": "إضافة تصنيف جديد",
  "Add New Employee": "إضافة موظف جديد",
  "Add New Restaurant": "إضافة مطعم جديد",
  "Add New Stock Item": "إضافة عنصر مخزون جديد",
  "Add New Table": "إضافة طاولة جديدة",
  "Add New {itemLabel}": "إضافة {itemLabel} جديد",
  "Add Recipe": "إضافة وصفة",
  "Add Row": "إضافة صف",
  "Add Service": "إضافة خدمة",
  "Add Stock Item": "إضافة عنصر مخزون",
  "Add Table": "إضافة طاولة",
  "Add Variant": "إضافة خيار",
  "Add a new restaurant to your portfolio": "أضف مطعمًا جديدًا إلى محفظتك",
  "Add items with photos, prices and stock, or import them from a spreadsheet.": "أضف المنتجات بالصور والأسعار والمخزون، أو استوردها من جدول بيانات.",
  "Add photos": "إضافة صور",
  "Add reward": "إضافة مكافأة",
  "Add size options like Small, Medium, Large with price adjustments": "أضف خيارات الحجم مثل صغير ومتوسط وكبير مع تعديل السعر",
  "Add to Cart": "أضف إلى السلة",
  "Add to bag": "أضف إلى الحقيبة",
  "Add to cart ·": "أضف إلى السلة ·",
  "Add to order": "أضف إلى الطلب",
  "Add to plate": "أضف إلى الطبق",
  "Add with Option": "إضافة مع خيار",
  "Add your accounts - they appear as icons on your website. Leave a field empty to hide it.": "أضف حساباتك - ستظهر كأيقونات على موقعك. اترك الحقل فارغًا لإخفائه.",
  "Add your email to get the confirmation": "أضف بريدك الإلكتروني لتلقي التأكيد",
  "Add your menu or products": "أضف قائمتك أو منتجاتك",
  "Add {name}": "إضافة {name}",
  "Add {name} to basket": "أضف {name} إلى السلة",
  "Add {name} to cart": "أضف {name} إلى السلة",
  "Add-ons": "الإضافات",
  "Added to cart": "تمت الإضافة إلى السلة",
  "Address *": "العنوان *",
  "Adjustment failed": "فشل التعديل",
  "Admin": "مدير",
  "After placing the order you can upload your transfer receipt - here or later from the order tracking page.": "بعد إتمام الطلب يمكنك رفع إيصال التحويل - هنا أو لاحقًا من صفحة تتبع الطلب.",
  "Alert at": "تنبيه عند",
  "All Actions": "كل الإجراءات",
  "All Active": "الكل نشط",
  "All Roles": "كل الأدوار",
  "All Status": "كل الحالات",
  "All Statuses": "كل الحالات",
  "All Transactions": "كل المعاملات",
  "All done - thank you!": "تم كل شيء - شكرًا لك!",
  "All reservations": "كل الحجوزات",
  "All rights reserved.": "جميع الحقوق محفوظة.",
  "All rows will be validated again before saving.": "سيتم التحقق من جميع الصفوف مرة أخرى قبل الحفظ.",
  "All services": "كل الخدمات",
  "Already have an account? ": "لديك حساب بالفعل؟ ",
  "Amount": "المبلغ",
  "Amount Paid": "المبلغ المدفوع",
  "Amount off": "مبلغ الخصم",
  "Amount to transfer": "المبلغ المطلوب تحويله",
  "Any special requests?": "هل لديك طلبات خاصة؟",
  "Anything we should know?": "هل هناك ما يجب أن نعرفه؟",
  "Anything we should know? (optional)": "هل هناك ما يجب أن نعرفه؟ (اختياري)",
  "Applicable tax": "الضريبة المطبقة",
  "Application Name": "اسم التطبيق",
  "Apply": "تطبيق",
  "Apply now (prorated)": "تطبيق الآن (بالتناسب)",
  "Appointments": "المواعيد",
  "Appointments & Reservations": "المواعيد والحجوزات",
  "Appointments & bookings": "المواعيد والحجوزات",
  "Appointments and rooms with live availability.": "مواعيد وغرف مع توفر مباشر.",
  "Appointments customers have requested": "المواعيد التي طلبها العملاء",
  "Appointments today": "مواعيد اليوم",
  "Approve": "موافقة",
  "Arabic & English": "العربية والإنجليزية",
  "Are you sure you want to delete the entire recipe for \"{menuItem}\"? This will remove all {length} ingredients.": "هل أنت متأكد من حذف الوصفة كاملة لـ \"{menuItem}\"؟ سيؤدي ذلك إلى حذف جميع المكونات ({length}).",
  "Are you sure you want to delete this category? This action cannot be undone.": "هل أنت متأكد من حذف هذا التصنيف؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to delete this menu item? This action cannot be undone.": "هل أنت متأكد من حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to delete this recipe ingredient?": "هل أنت متأكد من حذف هذا المكوّن من الوصفة؟",
  "Are you sure you want to delete this stock item? This action cannot be undone.": "هل أنت متأكد من حذف عنصر المخزون هذا؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to delete this table? This action cannot be undone.": "هل أنت متأكد من حذف هذه الطاولة؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to delete {filename}?": "هل أنت متأكد من حذف {filename}؟",
  "Are you sure you want to permanently delete {full_name}? This action cannot be undone.": "هل أنت متأكد من الحذف النهائي لـ {full_name}؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to restore from {filename}? This will replace all current data!": "هل أنت متأكد من الاستعادة من {filename}؟ سيؤدي ذلك إلى استبدال جميع البيانات الحالية!",
  "Are you sure you want to {action} \"{name}\"?": "هل أنت متأكد من {action} \"{name}\"؟",
  "Are you sure you want to {action} {full_name}?": "هل أنت متأكد من {action} {full_name}؟",
  "At least 6 characters.": "6 أحرف على الأقل.",
  "Auto dietary tags • Clean grid • Fresh palette": "وسوم غذائية تلقائية • شبكة نظيفة • ألوان منعشة",
  "Availability": "التوفر",
  "Available": "متاح",
  "Available Backups (": "النسخ الاحتياطية المتاحة (",
  "Available for ordering": "متاح للطلب",
  "Available for service": "متاح للخدمة",
  "Available times": "الأوقات المتاحة",
  "Average Amount": "متوسط المبلغ",
  "Average Order Value": "متوسط قيمة الطلب",
  "Avg Order Value": "متوسط قيمة الطلب",
  "Avg Price": "متوسط السعر",
  "Avg Service Time": "متوسط وقت الخدمة",
  "Avg. Order Value": "متوسط قيمة الطلب",
  "Awaiting confirmation": "بانتظار التأكيد",
  "BILL SUMMARY": "ملخص الفاتورة",
  "BY APPOINTMENT": "بموعد مسبق",
  "Back": "رجوع",
  "Back to Dashboard": "العودة إلى لوحة التحكم",
  "Back to basket": "العودة إلى السلة",
  "Back to collection": "العودة إلى التشكيلة",
  "Back to dashboard": "العودة إلى لوحة التحكم",
  "Back to home": "العودة إلى الرئيسية",
  "Back to store": "العودة إلى المتجر",
  "Back to the collection": "العودة إلى التشكيلة",
  "Back to the menu": "العودة إلى القائمة",
  "Background Color": "لون الخلفية",
  "Backup": "النسخ الاحتياطي",
  "Backup & Restore": "النسخ الاحتياطي والاستعادة",
  "Backup Information": "معلومات النسخ الاحتياطي",
  "Backup created successfully!": "تم إنشاء النسخة الاحتياطية بنجاح!",
  "Backup deleted successfully!": "تم حذف النسخة الاحتياطية بنجاح!",
  "Backup restored successfully! Please refresh the page.": "تمت استعادة النسخة الاحتياطية بنجاح! يرجى تحديث الصفحة.",
  "Balance updated": "تم تحديث الرصيد",
  "Bank account": "حساب بنكي",
  "Bank account linked via Stripe": "حساب بنكي مرتبط عبر Stripe",
  "Bank transfer": "تحويل بنكي",
  "Bank transfer receipt": "إيصال التحويل البنكي",
  "Bar - Nightlife": "بار - سهرات",
  "Base Price (": "السعر الأساسي (",
  "Base prices restaurants are offered - you can still override the price per restaurant individually.": "الأسعار الأساسية المعروضة على المطاعم - ويمكنك تعديل السعر لكل مطعم على حدة.",
  "Basic Information": "المعلومات الأساسية",
  "Basic application configuration": "إعدادات التطبيق الأساسية",
  "Bill Summary": "ملخص الفاتورة",
  "Billed monthly": "يُدفع شهريًا",
  "Billing": "الفوترة",
  "Billing portal is not available yet": "بوابة الفوترة غير متاحة بعد",
  "Black canvas, gold accents, serif type": "خلفية سوداء، لمسات ذهبية، خطوط كلاسيكية",
  "Black on white, one category at a time behind tabs": "أسود على أبيض، تصنيف واحد في كل مرة ضمن تبويبات",
  "Block": "حظر",
  "Blocked dates": "التواريخ المحظورة",
  "Bold - Streetwear Drop": "جريء - أزياء الشارع",
  "Book an Appointment": "احجز موعدًا",
  "Book another appointment": "احجز موعدًا آخر",
  "Book now": "احجز الآن",
  "Book your appointment online.": "احجز موعدك عبر الإنترنت.",
  "Booked": "محجوز",
  "Booking Page": "صفحة الحجز",
  "Booking Requested": "تم طلب الحجز",
  "Booking requested!": "تم طلب الحجز!",
  "Booking {status}": "الحجز {status}",
  "Booking...": "جارٍ الحجز...",
  "Bookings": "الحجوزات",
  "Border Radius (px)": "استدارة الحواف (px)",
  "Bottle": "زجاجة",
  "Box": "صندوق",
  "Branch": "الفرع",
  "Branch Code": "رمز الفرع",
  "Branch Code *": "رمز الفرع *",
  "Branding": "الهوية",
  "Brief description of the restaurant": "وصف مختصر للمطعم",
  "Bright colors, big one-tap add buttons": "ألوان زاهية وأزرار إضافة كبيرة بلمسة واحدة",
  "Browse templates": "تصفح القوالب",
  "Business Address": "عنوان النشاط",
  "Business types": "أنواع الأنشطة",
  "Busy": "مشغول",
  "CANCELLED": "ملغي",
  "CATEGORIES": "التصنيفات",
  "CHOOSE YOUR POISON": "اختر مشروبك",
  "COMPLETED": "مكتمل",
  "CONFIRMED": "مؤكد",
  "CUTS & PLATES": "القطع والأطباق",
  "Cafe - Chalkboard": "مقهى - سبورة",
  "Calm - Spa Treatment Menu": "هادئ - قائمة علاجات السبا",
  "Campaign history": "سجل الحملات",
  "Campaign queued for {total_recipients} customers": "تمت جدولة الحملة لـ {total_recipients} عميل",
  "Can I cancel anytime?": "هل يمكنني الإلغاء في أي وقت؟",
  "Can my website be in Arabic?": "هل يمكن أن يكون موقعي باللغة العربية؟",
  "Cancel": "إلغاء",
  "Cancel Payment": "إلغاء الدفع",
  "Cancel anytime. You pay the same amount every month by card or bank debit.": "يمكنك الإلغاء في أي وقت. تدفع المبلغ نفسه كل شهر بالبطاقة أو الخصم البنكي.",
  "Cancel subscription": "إلغاء الاشتراك",
  "Cancel this campaign? Remaining customers will not be messaged.": "إلغاء هذه الحملة؟ لن يتم إرسال الرسائل للعملاء المتبقين.",
  "Cancel this subscription at the end of the current billing period?": "إلغاء هذا الاشتراك في نهاية فترة الفوترة الحالية؟",
  "Cancelled": "ملغي",
  "Cannot delete all columns": "لا يمكن حذف جميع الأعمدة",
  "Cannot delete all rows": "لا يمكن حذف جميع الصفوف",
  "Cannot delete header row": "لا يمكن حذف صف العناوين",
  "Capacity *": "السعة *",
  "Capacity:": "السعة:",
  "Card": "بطاقة",
  "Card (Stripe)": "بطاقة (Stripe)",
  "Card order - the customer hasn't completed the Stripe payment yet.": "طلب بالبطاقة - لم يكمل العميل الدفع عبر Stripe بعد.",
  "Card payment failed. Please try again or use cash.": "فشل الدفع بالبطاقة. حاول مرة أخرى أو ادفع نقدًا.",
  "Card, bank transfer or cash on delivery": "بطاقة أو تحويل بنكي أو الدفع عند الاستلام",
  "Cart": "السلة",
  "Cart cleared": "تم إفراغ السلة",
  "Cart is empty": "السلة فارغة",
  "Carte du jour": "قائمة اليوم",
  "Cash": "نقدًا",
  "Cash Received": "النقد المستلم",
  "Cash Reconciliation": "تسوية النقد",
  "Cash Transactions": "المعاملات النقدية",
  "Cash reconciliation loaded successfully": "تم تحميل تسوية النقد بنجاح",
  "Cashier": "أمين الصندوق",
  "Cashier Dashboard": "لوحة أمين الصندوق",
  "Casual - Fast & Bold": "كاجوال - سريع وجريء",
  "Categories": "التصنيفات",
  "Categories (": "التصنيفات (",
  "Category": "التصنيف",
  "Category (optional)": "التصنيف (اختياري)",
  "Category *": "التصنيف *",
  "Category Name *": "اسم التصنيف *",
  "Category bubbles and a sliding row of colorful cards per category": "فقاعات للتصنيفات وصف منزلق من البطاقات الملونة لكل تصنيف",
  "Category deleted successfully": "تم حذف التصنيف بنجاح",
  "Category {v0} successfully": "تم {v0} التصنيف بنجاح",
  "Centered printed-menu look with dotted price leaders - spas, salons": "مظهر قائمة مطبوعة في المنتصف مع خطوط منقطة للأسعار - للسبا والصالونات",
  "Change": "الباقي",
  "Change image": "تغيير الصورة",
  "Change:": "الباقي:",
  "Changing currency converts current menu, product and service prices using a live exchange rate. Past orders stay in their original currency.": "تغيير العملة يحوّل أسعار القائمة والمنتجات والخدمات الحالية بسعر صرف مباشر. تبقى الطلبات السابقة بعملتها الأصلية.",
  "Check payment with Stripe": "التحقق من الدفع عبر Stripe",
  "Check the amount (": "تحقق من المبلغ (",
  "Check your connection and business assignment, then try again.": "تحقق من اتصالك ومن ربط حسابك بالنشاط، ثم حاول مرة أخرى.",
  "Checking...": "جارٍ التحقق...",
  "Checkout": "إتمام الطلب",
  "Checkout cancelled - nothing was charged.": "تم إلغاء الدفع - لم يتم خصم أي مبلغ.",
  "Choose a .json or .theme file first": "اختر ملف ‎.json أو ‎.theme أولًا",
  "Choose a day": "اختر يومًا",
  "Choose a plan first": "اختر خطة أولًا",
  "Choose a service and pick a time that works for you": "اختر خدمة ووقتًا يناسبك",
  "Choose a service, pick a free time on the calendar, and get your confirmation by email.": "اختر خدمة، ثم وقتًا متاحًا في التقويم، واحصل على التأكيد عبر البريد الإلكتروني.",
  "Choose a theme.json file": "اختر ملف theme.json"
}
